'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { tap } from 'rxjs/operators/tap';
import ContentRoutes from 'ContentUtils/Routes';
import { CLONED_CONTENT } from '../actions/ActionTypes';
import { closeModal } from '../actions/ModalActions';
import { requestCloneContent, requestedCloneContentFailure, requestedCloneContentSuccess } from '../actions/ContentActions';
export default ((action$, _, {
  ContentClient
}) => action$.ofType(CLONED_CONTENT).pipe(mergeMap(({
  payload: {
    categoryId,
    contentType,
    id,
    name
  }
}) => ContentClient.cloneContent(contentType, id, name).pipe(tap(({
  id: cloneId
}) => window.open(ContentRoutes.edit(cloneId, categoryId))), mergeMap(() => of(closeModal(), requestedCloneContentSuccess(contentType))), catchError(error => of(requestedCloneContentFailure(error, contentType))), startWith(requestCloneContent())))));